import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ConfigureService } from '@app/configure/services/configure.service';

@Component({
	selector: 'cng-progress-bar-static',
	templateUrl: './progress-bar-static.component.html',
	styleUrls: ['./progress-bar-static.component.less'],
})
export class ProgressBarStaticComponent implements OnInit {
	@Input() is_header: boolean;
	@Input() current_step_key: string;
	@Input() location: string;

	@Output() page_jump: EventEmitter<any> = new EventEmitter();

	configure_data: any = this.configure_service.configure_data;
	steps: [any];
	steps_display: string;
	current_step_index: number;
	constructor(private configure_service: ConfigureService) {}

	ngOnInit(): void {
		this.steps = this.configure_data.steps_order.map((step) => this.configure_data.steps[step]);
		this.steps_display = this.steps.map((step) => step.name).join(',');
		this.is_header && this.colorizeSteps();
	}

	colorizeSteps(): void {
		this.current_step_index = this.configure_data.steps_order.indexOf(this.current_step_key);
	}

	stepClickHandler(event, idx): void {
		event && event.stopPropagation();
		this.page_jump.emit(this.configure_data.steps_order[idx]);
	}
}
